import styles from './imagery.module.scss'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import cn from 'classnames'
import { useState } from 'react'
import { default as ImageComponent } from '@/components/Image'
import Modal from '@/components/Modal/Modal'
import PageHeader from '@/components/PageHeader/PageHeader'
import WYSIWYG from '@/components/WYSIWYG/WYSIWYG'
import ContentLayout from '@/layouts/ContentLayout'
import renderCustomIcon from '@/utils/renderCustomIcon'

function Template({ page, content }) {
  const acf = content.pageImageryAcf
  const allImages = acf.images.imageGroups.map((group) => group.images).flat(Infinity)
  const DownloadIcon = renderCustomIcon('download')

  return (
    <>
      <PageHeader data={content.sections} />

      <ContentLayout className={cn(styles['root'])}>
        <ContentLayout.Main>
          <ContentLayout.Main.IntroHeader className={cn(styles['root__introheader'])}>
            <ContentLayout.Main.IntroHeader.Content>
              <h1>{page.title}</h1>
            </ContentLayout.Main.IntroHeader.Content>
          </ContentLayout.Main.IntroHeader>

          <div>
            <section className={cn(styles['logos-section'])}>
              <h2>{"Logo's"}</h2>

              <ul>
                {acf.logoDownloads.downloads.map((download, index) => {
                  return (
                    <li key={index + download.file.mediaItemUrl}>
                      <a
                        className={cn(styles['download'])}
                        href={download.file.mediaItemUrl}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <DownloadIcon />

                        <p>
                          <span>Download</span> {download.fileName}
                        </p>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </section>

            <section className={cn(styles['images-section'])}>
              {acf.images.imageGroups.map((group) => {
                return (
                  <div
                    key={group.title}
                    className={cn(styles['group'])}
                  >
                    <div className={cn(styles['header'])}>
                      <h2>{group.imageGroupTitle}</h2>
                      <WYSIWYG>{group.imageGroupDescription}</WYSIWYG>
                    </div>

                    <ul>
                      {group.images.map((image) => {
                        return (
                          <li key={image.sourceUrl}>
                            <ImageModal
                              images={allImages}
                              data={image}
                            >
                              <ImageComponent data={image} />
                            </ImageModal>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                )
              })}
            </section>
          </div>
        </ContentLayout.Main>
      </ContentLayout>
    </>
  )
}

function ImageModal({ data, images, children }) {
  const lastImageIndex = images.length - 1
  const DownloadIcon = renderCustomIcon('download')

  const [isOpen, setIsOpen] = useState(false)
  const [activeImageIndex, setActiveImageIndex] = useState(0)

  function openModal() {
    setIsOpen(true)
    setActiveImageIndex(images.findIndex((image) => image.sourceUrl === data.sourceUrl))
  }

  function selectPreviousImage() {
    setActiveImageIndex(activeImageIndex === 0 ? lastImageIndex : activeImageIndex - 1)
  }

  function selectNextImage() {
    setActiveImageIndex(activeImageIndex === lastImageIndex ? 0 : activeImageIndex + 1)
  }

  return (
    <>
      <button
        type="button"
        onClick={openModal}
      >
        {children}
      </button>

      <Modal
        className={cn(styles['modal'])}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      >
        <div className={cn(styles['main'])}>
          <button
            type="button"
            onClick={selectPreviousImage}
          >
            <ChevronLeftIcon />
          </button>

          <ImageComponent data={images[activeImageIndex]} />

          <button
            type="button"
            onClick={selectNextImage}
          >
            <ChevronRightIcon />
          </button>
        </div>

        <a
          className={cn('mt-4', styles['download'])}
          href={images[activeImageIndex].sourceUrl}
          download
          target="_blank"
          rel="noreferrer"
        >
          <DownloadIcon />

          <p>
            <span>Download</span>
          </p>
        </a>
      </Modal>
    </>
  )
}

export default Template
